import imageCompression, { Options } from "browser-image-compression";
import { useState } from "react";

const useImagesCompressor = (options?: Options) => {
  const [compressingImagesCount, setCompressingImagesCount] = useState(0);

  const compressImages = async (files: File[]) => {
    setCompressingImagesCount(files.length);

    const compressedFiles = await Promise.all(
      files.map(async (file) =>
        file.type.startsWith("image") && file.type !== "image/gif"
          ? await imageCompression(file, {
              maxSizeMB: 0.1,
              maxWidthOrHeight: 2000,
              fileType: "image/webp",
              // Ceiling, not a target: browser-image-compression renders at
              // this quality and returns as soon as the result fits maxSizeMB,
              // never raising it to use the headroom. Starting at 1 lets it
              // step down to the 100 KB budget instead of stopping early and
              // shipping a needlessly lossy 40 KB file.
              initialQuality: 1,
              ...options
            })
          : file
      )
    );

    setCompressingImagesCount(0);

    return compressedFiles;
  };

  return { compressingImagesCount, compressImages };
};

export default useImagesCompressor;
